import {
  GenerateRandomId,
  chromeExtension,
  productID,
  extensionName,
  reqEventName,
  respEventName
} from '../const/cryptokit.js'

import errorMap from './errorMap'

import {standardBrowser, BrowserInfo} from '../const/browser.js'

function errorHandler(err){
  let {result} = err
  if(!result) return
  for(let key in errorMap){
    let msg = errorMap[key]
    let isIn = result.includes(key)
    if(isIn){
      err.result = msg
    }
  }
}
const isChrome = BrowserInfo.name === standardBrowser.Chrome
// 统一错误处理规则
// 返回为null， Extension has been remove

const SendMsgforChrome = (request) => {
  return new Promise((resolve, reject)=> {
    chrome.runtime.sendMessage(chromeExtension, request, (response)=> {
      if (response) {
				if(response.errorcode == 0){ 
          resolve(response)                                    
				} else { 
          if(response.errorcode == 1) {
            errorHandler(response)
            reject(response)
          }else{
            return getLastErrorDesc().then((res) => {
              errorHandler(res)
              reject(res)
            })
          }
				}
			} else {
			    reject({errorcode:1, result: '验证失败，请确保插件已安装并打开'})
			}
    })
  })
}


const SendMsgByEvent = (request)=> {
  let event = new CustomEvent(reqEventName, { detail: request })
  document.dispatchEvent(event)

  return new Promise((resolve, reject)=> {
    let responseEventName = respEventName
    if(request.funcInfo != undefined && request.funcInfo.randomId != undefined){
      responseEventName += ("." + request.funcInfo.randomId)
    }
    document.addEventListener(responseEventName, CallBack = (e)=>{
      document.removeEventListener(e.type, CallBack)
      var eJson = JSON.parse(e.detail)
        if (eJson && eJson.errorcode == 0) {
          resolve(eJson)
        } else {
          reject(eJson)
        }
    }, false)
  })
}

export const SendMsg = (requestJSON)=> {
  if (isChrome) {
    return SendMsgforChrome(requestJSON)
  } else {
    return SendMsgByEvent(requestJSON)
  }
}

export const getLastErrorDesc = ()=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'GetLastErrorDesc',
      params: null,
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}


// WEBPACK FOOTER //
// ./apps/cfca/cryptokit/sendMsg/index.js